<template>
  <modal name="modal-gmb-photo" :has-apply="false" @closed="closed" :cancel-label="$t('common.button.close')">
    <template v-slot:container>
      <div class="modal-gmb-photo__preview">
        <div class="modal-gmb-photo__top">
          <ui-button
            class="modal-gmb-photo__top__link"
            button="secondary"
            :label="$t('modal.gmbPhoto.button.link')"
            icon="external_link"
            :icon-only="true"
            :is-link="true"
            :href="photo.googleUrl"
          />
          <v-popover placement="bottom-end" :autoHide="true" popoverInnerClass="popover-inner no-overflow">
            <ui-button
              class="modal-gmb-photo__top__delete"
              button="secondary"
              :label="$t('modal.gmbPhoto.button.delete.label')"
              icon="delete"
              :icon-only="true"
              v-if="type === 'owner'"
            />
            <template slot="popover">
              <div class="modal-gmb-photo__popover__container">
                <div class="modal-gmb-photo__popover__container__text">
                  {{ $t('modal.gmbPhoto.button.delete.popover.label') }}
                </div>
                <div class="modal-gmb-photo__popover__container__buttons">
                  <ui-button
                    class="modal-gmb-photo__popover__container__buttons__delete"
                    button="secondary"
                    :label="$t('modal.gmbPhoto.button.delete.popover.yes')"
                    @click="deletePhoto"
                  />
                  <ui-button :label="$t('modal.gmbPhoto.button.delete.popover.no')" v-close-popover button="primary" />
                </div>
              </div>
            </template>
          </v-popover>
          <ui-button
            class="modal-gmb-photo__top__report"
            button="secondary"
            :label="$t('modal.gmbPhoto.button.report')"
            icon="flag"
            :icon-only="true"
            v-if="type === 'customer'"
            :is-link="true"
            :href="photo.attribution.takedownUrl"
          />
          <v-popover placement="bottom-end" :autoHide="true" popoverInnerClass="popover-inner no-overflow">
            <ui-button
              class="modal-gmb-photo__top__details"
              button="secondary"
              :label="$t('modal.gmbPhoto.button.details')"
              icon="info"
              :icon-only="true"
            />
            <template slot="popover">
              <div class="modal-gmb-photo__popover__container">
                <div
                  class="modal-gmb-photo__popover__container__stat"
                  v-if="photo.attribution && photo.attribution.profileName"
                >
                  <span
                    class="
                      modal-gmb-photo__popover__container__stat__icon
                      modal-gmb-photo__popover__container__stat__icon--link
                      backoffice-icons
                    "
                    >account</span
                  >
                  <a
                    class="modal-gmb-photo__popover__container__stat__link"
                    :href="photo.attribution.profileUrl"
                    target="_blank"
                  >
                    {{ photo.attribution.profileName }}
                  </a>
                </div>
                <div class="modal-gmb-photo__popover__container__stat" v-if="photo.insights.viewCount">
                  <span class="modal-gmb-photo__popover__container__stat__icon backoffice-icons">visibility</span>
                  {{
                    $t('modal.gmbPhoto.label.views', {
                      views: photo.insights.viewCount,
                    })
                  }}
                </div>
                <div class="modal-gmb-photo__popover__container__stat">
                  <span class="modal-gmb-photo__popover__container__stat__icon backoffice-icons">photo</span>
                  {{
                    $t('modal.gmbPhoto.label.pixels', {
                      width: photo.dimensions.widthPixels,
                      height: photo.dimensions.heightPixels,
                    })
                  }}
                </div>
                <div class="modal-gmb-photo__popover__container__stat">
                  <span class="modal-gmb-photo__popover__container__stat__icon backoffice-icons">date</span>
                  {{ formatedTime(photo.createTime) }}
                </div>
                <div class="modal-gmb-photo__popover__container__stat" v-if="type === 'owner'">
                  <span class="modal-gmb-photo__popover__container__stat__icon backoffice-icons">attribut</span>
                  {{ $t(`locationsGmb.id.photos.section.categories.${photo.locationAssociation.category}`) }}
                </div>
              </div>
            </template>
          </v-popover>
        </div>
        <img :src="photo.googleUrl" class="modal-gmb-photo__preview__img" />
      </div>
    </template>
  </modal>
</template>

<script>
import UiButton from '@/components/UI/Button.vue'
import { timeFromNow } from '@/utils/hours.util'

export default {
  name: 'ModalGmbPhoto',
  components: {
    UiButton,
  },
  props: {
    photo: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    deletePhoto() {
      this.$emit('deletePhoto', this.photo)
      this.closed()
    },
    closed() {
      this.$emit('closed')
    },
    formatedTime(time) {
      return timeFromNow(time, this.$i18n.locale, true)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-gmb-photo {
  &__top {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    justify-content: flex-end;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
    padding: 8px;

    &__link,
    &__delete,
    &__details,
    &__report {
      color: $generic-color-text-alt;
    }

    &__delete,
    &__report,
    &__details {
      margin-left: $gutter-mobile / 2;
    }
  }

  &__preview {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -$gutter-mobile;

    @media (min-width: $screen-sm) {
      margin: -$gutter-tablet;
    }

    &__img {
      max-width: 100%;
    }
  }

  &__popover {
    &__container {
      display: flex;
      flex-direction: column;
      padding: $gutter-mobile;

      @media (min-width: $screen-sm) {
        padding: $gutter-tablet;
      }

      &__text {
        margin-bottom: 1rem;
      }

      &__buttons {
        &__delete {
          color: map-get($generic-color-variants, 'error');
        }
      }

      &__stat {
        display: flex;
        align-items: center;
        margin-bottom: $gutter-mobile;

        @media (min-width: $screen-sm) {
          margin-bottom: $gutter-tablet;
        }

        &__link {
          color: $black;

          &:hover {
            color: var(--product-color);
          }
        }

        &:last-child {
          margin-bottom: 0;
        }

        &__icon {
          margin-right: 16px;
        }
      }
    }
  }
}
</style>
